export default __webpack_public_path__ + "static/media/payment-options-paytrail.9668b46e.png";